// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#payables a,
.payables,
.payables .panel-heading,
.payables label,
.payables .list-group-item {
  color: #b35900 !important;
}

#receivables a,
.receivables,
.receivables .panel-heading,
.receivables label,
.receivables .list-group-item {
  color: #008000 !important;
}
@media print {
  .card {
    box-shadow: none;
    margin-bottom: 0px;
  }
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
